"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12 5c-1.933 0-3.683.7835-4.9497 2.0503L5.636 5.636C7.2647 4.0074 9.5147 3 12 3c4.9706 0 9 4.0294 9 9h2l-3 3-3-3h2c0-3.866-3.134-7-7-7zm0 16c-4.9706 0-9-4.0294-9-9H.996l3-3 3 3H5c0 3.866 3.134 7 7 7 1.933 0 3.683-.7835 4.9497-2.0503l1.4143 1.4143C16.7353 19.9926 14.4853 21 12 21z"
  })];
};

exports.default = _default;